import Props from "./props";
import React from "react";
import Styled from "./styled";
import refactorProps from "../../../../helpers/refactorProps";

const Input: React.FC<Props> = ({ type = "text", name, placeholder, value, defaultValue, autocomplete, onChange }) => {
    return (
        <>
            <Styled
                {...refactorProps({
                    type,
                    name,
                    placeholder,
                    value,
                    defaultValue,
                    autocomplete,
                    onChange
                })}
            />
            <span />
        </>
    );
};

export default Input;
